module.exports = __webpack_public_path__ + "img/Zapzaraptor.ad36e586.jpg";